/// <reference path="IconShapeUI.js"/>

!(function (sb) {
	var me = (sb.IconShapeCache = {});
	var IconShapeSettingsCache = {};

	me.setIconShapeSettingsToCache = function (data, id) {
		IconShapeSettingsCache[id] = data;
	};
	me.getIconShapeSettingsFromCache = function (id) {
		return IconShapeSettingsCache[id];
	};
})(window.Storyboard = (window.Storyboard || {}));

window.IconShapeSetup = {
	libraryEdit: false,
	libraryRequestedFrom: "",
	libraryLoaded: false,

	setupEditPanel: function (elementItem) {
		IconShapeSetup.setupEditMode(false);
		IconShapeUI.resetSelections();
		IconShapeUI.resetIconFilters();

		IconShapeUI.setupPreview(elementItem);

		Storyboard.Dependency.start('ICONSHAPESETUP', 'settings');
		Helpers.perfJSonCall({
			method: "GetIconShapeSettingsForElementItem",
			message: "Loading settings",
			data: {
				guid: elementItem.guid, elementItemId: elementItem.elementItemId || 0
			},
			successCallback: function (settings) {
				IconShapeSetup.bindIconShapeSettings(settings);
				Storyboard.IconShapeCache.setIconShapeSettingsToCache(settings, elementItem.guid);
				Storyboard.Dependency.complete('ICONSHAPESETUP', 'settings');
			},
			failCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to load icon/shape settings."));
			},
			fixCasing: true
		});
	},

	setupLibraryEditPanel: function (iconShapeId, requestedFrom, defaultSettings) {
		$("#iconPreviewSvg").empty();
		IconShapeSetup.libraryEdit = true;
		IconShapeSetup.libraryRequestedFrom = requestedFrom;

		$(requestedFrom).hide();
		$('#setupHolder').show();
		$("#setupIconShapeTab").show();
		$("#DUI-ST-SAVESETTINGS, #DUI-ST-MULTIEDIT").hide();
		
		if ($('#editPanelTitle').val() === '') {
			$('#editPanelTitle').val('Icon / shape');
		}

		IconShapeSetup.loadTabs();
		IconShapeSetup.setupEditMode(true);
		IconShapeUI.resetSelections();
		IconShapeUI.resetIconFilters();

		IconShapeUI.setupPreview();

		var settingsToUse = iconShapeId ? Storyboard.IconShapeCache.getIconShapeSettingsFromCache("zoneIcon_" + iconShapeId) : null;
		if (settingsToUse && settingsToUse.iconShapeId)
			IconShapeSetup.bindIconShapeSettings(settingsToUse);
		else if (iconShapeId > 0)
			Helpers.perfJSonCall({
				method: "GetIconShapeSettings",
				data: {
					iconShapeId: iconShapeId
				},
				successCallback: function (settings) {
					IconShapeSetup.bindIconShapeSettings(settings);
					Storyboard.IconShapeCache.setIconShapeSettingsToCache(settings, "zoneIcon_" + settings.iconShapeId);
				},
				failCallback: function () {
					Storyboard.LayoutControls.showMessage(locale.get("Unable to load icon/shape settings."));
				},
				fixCasing: true
			});
		else if (defaultSettings)
			IconShapeSetup.bindIconShapeSettings(defaultSettings);
		else {
			$("#ddliconFilterCategories").val("icon-").trigger("change");
			IconShapeUI.onIconChanged("icon-");
			IconShapeSetup.bindIconShapeStyles(IconShapeUI.getDefaultStyles());
			IconShapeUI.EventsManager.setEventsTabUI();
		}
	},

	bindIconShapeSettings: function (settings) {
		// bind loaded or default settings
		if (settings) {
			$("#hidIconShapeId").val(settings.iconShapeId || 0);
			$("#hidIconShapeKey").val(settings.iconShapeKey || "");
			IconShapeSetup.bindIconShapeStyles(settings.styles);
			IconShapeUI.EventsManager.setEventsTabUI(settings);
			if (settings.iconShapeKey) {
				if (settings.objectType == 2)
					IconShapeUI.setSelectedShape(settings.iconShapeKey);
				else
					IconShapeUI.setSelectedIcon(settings.iconShapeKey);
				IconShapeUI.updatePreview();
			}
			else {
				$("#ddliconFilterCategories").val("icon-").trigger("change");
				IconShapeUI.onIconChanged("icon-");
            }
		} else {
			$("#ddliconFilterCategories").val("icon-").trigger("change");
			IconShapeUI.onIconChanged("icon-");
			IconShapeUI.EventsManager.setEventsTabUI();
			IconShapeSetup.bindIconShapeStyles(IconShapeUI.getDefaultStyles());
		}
	},

	bindIconShapeStyles: function (styles) {
		if (!styles || typeof styles !== "object") return;

		$(styles).each(function() {
			var styleKey = this.styleKey;
			var styleValue = this.styleValue;
			var styleControl = $("#si_style_" + styleKey.replace('_colorPlaceholderId', ''));
			var color, colorId;

			if ($(styleControl).is("input:radio") || $(styleControl).is("input:checkbox"))
				$(styleControl).attr("checked", styleValue.toLowerCase() == "true");
			else if ($(styleControl).hasClass("ColorTextbox")) {
				if (~styleKey.indexOf('_colorPlaceholderId')) {
					colorId = this.styleValue;
					color = styles.filter(function(style) { return style.styleKey === styleKey.replace('_colorPlaceholderId', ''); })[0];
					color = color ? color.styleValue : null;
				} else {
					colorId = styles.filter(function(style) { return style.styleKey === styleKey + '_colorPlaceholderId'; })[0];
					colorId = colorId ? colorId.styleValue : null;
					color = this.styleValue;
				}
				$(styleControl).DUIColorPicker({
					layout: 'template',
					selected: {
						colorString: color,
						templateColorId: colorId
					}
				});
			}
			else if (styleKey === "padding")
				$(styleControl).val(styleValue + "%");
			else if (styleKey === "rotate")
				$(styleControl).val(styleValue + "°");
			else
				$(styleControl).val(styleValue);
		});

		$("#is_layout .iconColorSettings > .settingControl").css('visibility', 'hidden');
		$("#is_layout .iconColorSettings input:radio:checked").parent().parent().next().css('visibility', '');
	},

	setupContextMenu: function (layoutElement) {
		var layoutElementItem = Storyboard.LayoutDesigner.getElementItemByType(Storyboard.Constants.itemTypes.ICONSHAPE, layoutElement);
		var settings = Storyboard.IconShapeCache.getIconShapeSettingsFromCache(layoutElementItem.guid);

		if (settings) {
			IconShapeSetup.bindContextMenuSettings(settings);
		} else {
			Helpers.perfJSonCall({
				method: "GetIconShapeSettingsForElementItem",
				data: {
					guid: layoutElementItem.guid, elementItemId: layoutElementItem.elementItemId || 0
				},
				successCallback: function (settings) {
					IconShapeSetup.bindContextMenuSettings(settings);
					Storyboard.IconShapeCache.setIconShapeSettingsToCache(settings, layoutElementItem.guid);
				},
				failCallback: function () {
					Storyboard.LayoutControls.showMessage(locale.get("Unable to load icon/shape settings."));
				},
				fixCasing: true
			});
		}
	},

	bindContextMenuSettings: function (settings) {
		if (!settings || typeof settings !== "object") return;
		var ctxMenuStyles = {};

		ctxMenuStyles.useColor = IconShapeSetup.getStyleByKey("use_color", settings.styles);
		ctxMenuStyles.useGradient =	IconShapeSetup.getStyleByKey("use_gradient", settings.styles);
		ctxMenuStyles.opacity = IconShapeSetup.getStyleByKey("opacity", settings.styles);

		$("#DUI-ST-CM-OPACITY").val(ctxMenuStyles.opacity).closest("li").show();

		if (ctxMenuStyles.useColor === "True" || settings.iconShapeKey === "Line") {
			if (settings.iconShapeKey && settings.iconShapeKey === "Line") {
				ctxMenuStyles.color = IconShapeSetup.getStyleByKey("stroke", settings.styles);
				ctxMenuStyles.colorId = IconShapeSetup.getStyleByKey("stroke_colorPlaceholderId", settings.styles);
			} else {
				ctxMenuStyles.color = IconShapeSetup.getStyleByKey("color", settings.styles);
				ctxMenuStyles.colorId = IconShapeSetup.getStyleByKey("color_colorPlaceholderId", settings.styles);
			}
			$("#DUI-ST-CM-COLOR").DUIColorPicker({
				layout: 'template',
				selected: {
					colorString: ctxMenuStyles.color,
					templateColorId: ctxMenuStyles.colorId
				}
			}).closest("li").show();
		} else if (ctxMenuStyles.useGradient === "True") {
			ctxMenuStyles.gradientStop1Color = IconShapeSetup.getStyleByKey("gradient_stop_1_stop-color", settings.styles);
			ctxMenuStyles.gradientStop1ColorId = IconShapeSetup.getStyleByKey("gradient_stop_1_stop-color_colorPlaceholderId", settings.styles);
			ctxMenuStyles.gradientStop2Color = IconShapeSetup.getStyleByKey("gradient_stop_2_stop-color", settings.styles);
			ctxMenuStyles.gradientStop2ColorId = IconShapeSetup.getStyleByKey("gradient_stop_2_stop-color_colorPlaceholderId", settings.styles);
			$("#DUI-ST-CM-GRADIENT-COLOR-1").DUIColorPicker({
				layout: 'template',
				selected: {
					colorString: ctxMenuStyles.gradientStop1Color,
					templateColorId: ctxMenuStyles.gradientStop1ColorId
				}
			});
			$("#DUI-ST-CM-GRADIENT-COLOR-2").DUIColorPicker({
				layout: 'template',
				selected: {
					colorString: ctxMenuStyles.gradientStop2Color,
					templateColorId: ctxMenuStyles.gradientStop2ColorId
				}
			}).parent().css("margin-left", 10).closest("li").show();
		}

		$(".DUIContextMenuParent.DUIContextMenuIconShape").toggle(settings.objectType == 1);
	},

	saveContextMenu: function (iconShapeElementItem, settings) {
		var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByElementItem(iconShapeElementItem);

		var data = {
			elementItem: iconShapeElementItem,
			iconShape: settings
		};

		Helpers.perfJSonCall({
			method: "SaveIconShapeSettings",
			message: "Saving icon/shape settings",
			data: data,
			successCallback: function () {
				iconShapeElementItem.content = data.iconShape.content;
				Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);

				if (!Storyboard.LayoutDesigner.isUnsaved && layoutElement.layoutElementId > 0)
					Storyboard.LayoutDesigner.refreshSlideToplineCompatibility();
			},
			failCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to save icon/shape settings."));
			}
		});
	},

	saveSetup: function (iconShapeElementItem) {
		var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByElementItem(iconShapeElementItem);

		var data = {
			elementItem: iconShapeElementItem,
			iconShape: IconShapeSetup.getIconShapeSettings()
		};

		Helpers.perfJSonCall({
			method: "SaveIconShapeSettings",
			message: "Saving icon/shape settings",
			data: data,
			successCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Icon/shape settings have been saved."));
				iconShapeElementItem.content = data.iconShape.content;
				Storyboard.LayoutDesigner.updateLayoutElement(layoutElement);
				Storyboard.IconShapeCache.setIconShapeSettingsToCache(data.iconShape, iconShapeElementItem.guid);
			},
			failCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to save icon/shape settings."));
			}
		});
	},

	saveLibraryIconSetup: function () {
		var data = {
			elementItem: null,
			iconShape: IconShapeSetup.getIconShapeSettings()
		};

		Helpers.perfJSonCall({
			method: "SaveIconShapeSettings",
			message: "Saving icon/shape settings",
			data: data,
			successCallback: function (result) {
				Storyboard.LayoutControls.showMessage(locale.get("Icon/shape settings have been saved."));
				data.iconShape.iconShapeId = result.iconShapeId;

				Storyboard.IconShapeCache.setIconShapeSettingsToCache(data.iconShape, "zoneIcon_" + data.iconShape.iconShapeId);
				if (IconShapeSetup.libraryRequestedFrom == "#setupDynamicIconShapeTab")
					DynamicIconShapeSetup.updateThumbnail(data.iconShape);
				else if (IconShapeSetup.libraryRequestedFrom == "#setupChart")
					ChartSetupUI.updateThumbnail(data.iconShape);
				else if (IconShapeSetup.libraryRequestedFrom == "vis-item-editor")
					Storyboard.EventBus.emit(Storyboard.Constants.Events.LIBRARY_ICON_SETUP_SAVED, data.iconShape);
				else if (IconShapeSetup.libraryRequestedFrom == "#formattingRules, #setupChart")
					document.getElementById("ifrRules").contentWindow.updateThumbnail(data.iconShape);
				else if (IconShapeSetup.libraryRequestedFrom == "#respFormattingRules, #setupRespondentTab")
					document.getElementById("ifrRespRules").contentWindow.updateThumbnail(data.iconShape);

				IconShapeSetup.closeLibraryEdit();
			},
			failCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to save icon/shape settings."));
			}
		});
	},

	copyZoneIcon: function (iconId, rowCopy) {
		Helpers.perfJSonCall({
			method: "CopyZoneIconShape",
			message: "Copying icon/shape",
			data: { iconShapeId: iconId },
			successCallback: function (copyId) {
				rowCopy.find("#hidZoneIconId").val(copyId);
			},
			failCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to copy icon/shape settings."));
			}
		});
	},

	redrawIconShape: function(iconShapeElem) {
		var element = $("#" + iconShapeElem.guid);
		var content = iconShapeElem.content;
		var svg, title, elementShape;

		try {
			if (content) {
				element.html(IconShapeUI.fixGUIDs(content, iconShapeElem.guid));
				svg = $(element).find('svg');
				title = svg.find('title');
				elementShape = svg.find('.element-shape');

				// Move shape type to class name for old shape objects
				// that have type saved in title element
				if (title.length > 0 && elementShape.length > 0) {
					elementShape.get(0).setAttribute('class', 'element-shape element-shape-' + title.text())
				}

				title.remove();
				
				IconShapeUI.EventsManager.addEventsToSvgElement(svg.get(0));

				if (!Helpers.isPreview())
					$(element).css({ 'background-image': "none" });
			}
		}
		catch (e) {
			Helpers.logErr(e);
		}
	},

	getIconShapeSettings: function () {
		var settings = {
			iconShapeId: $("#hidIconShapeId").val() || 0,
			objectType: $("#hidIconShapeType").val() || 1,
			iconShapeKey: $("#hidIconShapeKey").val() || "",
			styles: IconShapeSetup.getIconShapeStyles(),
			content: IconShapeUI.getPreviewSvg()
		};

		return settings;
	},

	getSelectedIconShapeKey: function (selector, substring) {
		var xlinkNs = "http://www.w3.org/1999/xlink";
		var use = $(".iconSelect.selected", selector).firstChild;
		return use.getAttributeNS(xlinkNs, "href").substr(substring);
	},

	getStyleByKey: function(key, stylesArray) {
		for (var i = 0, style; (style = stylesArray[i]); i++)
			if (style.styleKey == key)
				return style.styleValue;
		return null;
	},

	setStyleByKey: function(key, value, stylesArray) {
		for (var i = 0, style; (style = stylesArray[i]); i++) {
			if (style.styleKey == key) {
				style.styleValue = value;
				return;
			}
		}

		stylesArray.push({styleKey: key, styleValue: value});
	},

	getIconShapeStyles: function () {
		var styles = [];
		$("#is_layout [id^='si_style_']").each(function () {
			var key = $(this).attr("id").replace("si_style_", "");
			var value;

			if ($(this).is("input:radio") || $(this).is("input:checkbox"))
				value = ($(this).is(":checked") ? "True" : "False");
			else if ($(this).is("select"))
				value = $(this).val();
			else if ($(this).hasClass("ColorTextbox"))
				value = (
					typeof this.style.backgroundColor == "undefined" ||
					this.style.backgroundColor.replace(/ /g, "").indexOf("(255,255,255,0") > -1 ||
					this.style.backgroundColor.toLowerCase() === "transparent"
					)
					? "rgba(255, 255, 255, 0.001)"
					: this.style.backgroundColor;
			else if (key === "padding")
				value = $(this).val().replace("%", "");
			else if (key === "rotate")
				value = $(this).val().replace("°", "");
			else
				value = $(this).val();

			styles.push({
				styleKey: key,
				styleValue: value
			});

			if ($(this).hasClass('colorpicker-target') && $(this).DUIColorPicker('get.selectedColorId')) {
				var colorId = $(this).DUIColorPicker('get.selectedColorId');
				if (colorId) {
					styles.push({
						styleKey: key + '_colorPlaceholderId',
						styleValue: colorId
					});
				}
			}
		});
		return styles;
	},

	setCalculatedAttributesToStylesObject: function(iconShapeSettings) {
		var content = iconShapeSettings.content;

		if (!content) return

		var parser = new DOMParser();
		var doc = parser.parseFromString(content, "text/html");

		if (!doc) return;

		var rotationEl = doc.querySelector('.group-rotation');
		var circleEl = doc.querySelector('.element-shape-Circle');
		var ellipseEl = doc.querySelector('.element-shape-Ellipse');

		if (rotationEl) {
			var transformStyle = rotationEl.getAttribute('transform') || '';
			var transformStylesObj = (transformStyle.match(/([\w]+)\(([^)]+)\)/g)||[]) 
				.map(function(it){return it.replace(/\)$/,"").split(/\(/)})
				.reduce(function(m,it){return m[it[0]]=it[1],m},{});

			if (transformStylesObj.scale) {
				IconShapeSetup.setStyleByKey('rotate_scale', transformStylesObj.scale, iconShapeSettings.styles);
			} else {
				iconShapeSettings.styles = iconShapeSettings.styles.filter(function(style) {
					return style.styleKey !== 'rotate_scale';
				});
			}

			if (transformStylesObj.translate) {
				var translateParts = transformStylesObj.translate.split(' ');
				IconShapeSetup.setStyleByKey('rotate_translate_x', translateParts[0], iconShapeSettings.styles);
				IconShapeSetup.setStyleByKey('rotate_translate_y', translateParts[1], iconShapeSettings.styles);
			} else {
				iconShapeSettings.styles = iconShapeSettings.styles.filter(function(style) {
					return style.styleKey !== 'rotate_translate_x' && style.styleKey !== 'rotate_translate_y';
				});
			}
		} else {
			iconShapeSettings.styles = iconShapeSettings.styles.filter(function(style) {
				return style.styleKey !== 'rotate_scale' && style.styleKey !== 'rotate_translate_x' && style.styleKey !== 'rotate_translate_y';
			});
		}

		if (circleEl) {
			IconShapeSetup.setStyleByKey('circle_cx', circleEl.getAttribute('cx'), iconShapeSettings.styles);
			IconShapeSetup.setStyleByKey('circle_cy', circleEl.getAttribute('cy'), iconShapeSettings.styles);
			IconShapeSetup.setStyleByKey('circle_r', circleEl.getAttribute('r'), iconShapeSettings.styles);
		} else {
			iconShapeSettings.styles = iconShapeSettings.styles.filter(function(style) {
				return style.styleKey !== 'circle_cx' && style.styleKey !== 'circle_cy' && style.styleKey !== 'circle_r';
			});
		}

		if (ellipseEl) {
			IconShapeSetup.setStyleByKey('ellipse_cx', ellipseEl.getAttribute('cx'), iconShapeSettings.styles);
			IconShapeSetup.setStyleByKey('ellipse_cy', ellipseEl.getAttribute('cy'), iconShapeSettings.styles);
			IconShapeSetup.setStyleByKey('ellipse_rx', ellipseEl.getAttribute('rx'), iconShapeSettings.styles);
			IconShapeSetup.setStyleByKey('ellipse_ry', ellipseEl.getAttribute('ry'), iconShapeSettings.styles);
		} else {
			iconShapeSettings.styles = iconShapeSettings.styles.filter(function(style) {
				return style.styleKey !== 'ellipse_cx' && style.styleKey !== 'ellipse_cy' && style.styleKey !== 'ellipse_rx' && style.styleKey !== 'ellipse_ry';
			});
		}
	},

	loadTabs: function () {
		$("#iconShapeSettingsTabHolder").tabs("destroy");
		$("#iconShapeSettingsTabHolder").removeClass("ui-widget");
		$("#iconShapeSettingsTabHolder").tabs({
			show: function (evt, ui) {
				$("#iconShapeSettingsTabHolder #panels").css("width", (ui.index === 0 ? "65%" : ""));
			}
		});
	},

	setupEditMode: function (libraryEdit) {
		$("#zoneIconsLibrary").toggle(libraryEdit);
		$(".iconColorSettings").toggle(!(libraryEdit && $("#chbPartlyFill").is(":checked")));
		$("a[href='#is_events']").closest("li").css("display",
			((IconShapeSetup.libraryEdit && IconShapeSetup.libraryRequestedFrom.indexOf("#setupChart") > - 1) ||
				(IconShapeSetup.libraryEdit && IconShapeSetup.libraryRequestedFrom.indexOf("#setupRespondentTab") > - 1)) ? "none" : "");

		if (!window.IsStoryboard) $("#is_events .layoutElementLinkEvent").hide();
	},

	closeLibraryEdit: function () {
		$(IconShapeSetup.libraryRequestedFrom).show();
		if (IconShapeSetup.libraryRequestedFrom === 'vis-item-editor' || Storyboard?.Elements?.ItemEditorRegion?.isOpen) {
			$('#setupHolder').hide();
		}
		$("#setupIconShapeTab").hide();
		$("#DUI-ST-SAVESETTINGS").show();
		IconShapeSetup.libraryEdit = false;
	},

	showHideZoneIconControls: function () {
		$("#ddlZoneIconShapeSelector, #btnUpdateZoneIconShape, #btnDeleteZoneIcon")
			.toggle($("#ddlZoneIconShapeSelector option").length > 0);
	}
};
